export default __webpack_public_path__ + "static/media/23.ebae85f1.jpeg";